import { Box, Circle, HStack, Link, Text } from '@chakra-ui/react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';

import { useLearnerDashboard } from '../hooks/useLearnerDashboard';

export default function LearnerDashboardMobileNavigation() {
  const { navItems } = useLearnerDashboard();
  const location = useLocation();
  const { pathname } = location;
  const containerRef = useRef<HTMLDivElement>(null);
  const activeLinkRef = useRef<HTMLAnchorElement>(null);

  // Auto-scroll active link to center
  useEffect(() => {
    if (activeLinkRef.current && containerRef.current) {
      const container = containerRef.current;
      const activeLink = activeLinkRef.current;

      const containerRect = container.getBoundingClientRect();
      const linkRect = activeLink.getBoundingClientRect();

      const containerCenter = containerRect.left + containerRect.width / 2;
      const linkCenter = linkRect.left + linkRect.width / 2;
      const scrollOffset = linkCenter - containerCenter;

      container.scrollBy({
        left: scrollOffset,
        behavior: 'smooth',
      });
    }
  }, [pathname]);

  return (
    <HStack ref={containerRef} gap={0} overflowX="auto">
      {navItems.map((item) => {
        const isActive = pathname.split('/').at(-1) === item.route.split('/').at(-1);

        return (
          <Link
            key={item.route}
            ref={isActive ? activeLinkRef : null}
            as={RouterLink}
            to={item.route}
            width="fit-content"
            minWidth="fit-content"
            fontWeight={600}
            fontSize="16px"
            color={isActive ? 'baseBlack' : 'neutral.700'}
            borderBottom={isActive ? '2px solid' : 'none'}
            borderColor="brand.primary"
            paddingTop={2}
            paddingBottom={4}
            paddingX={4}
          >
            <HStack>
              <Text>{item.label}</Text>

              {item.count && (
                <Box
                  paddingX="5px"
                  paddingY="3px"
                  backgroundColor="neutral.100"
                  borderRadius="full"
                >
                  <Text fontSize="10px" fontWeight={600} color="neutral.700">
                    {item.count}
                  </Text>
                </Box>
              )}
            </HStack>
          </Link>
        );
      })}
    </HStack>
  );
}
